import { render, staticRenderFns } from "./AgendamentoClinicas.vue?vue&type=template&id=8db61ff0&scoped=true&"
import script from "./AgendamentoClinicas.vue?vue&type=script&lang=js&"
export * from "./AgendamentoClinicas.vue?vue&type=script&lang=js&"
import style0 from "./AgendamentoClinicas.vue?vue&type=style&index=0&id=8db61ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db61ff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSkeletonLoader,VTextField})
